import { TicketDetail } from '../../types';
import { Typography } from 'antd';
import { GreenCheck } from '../../assets';
import { requestform } from '../../messages';
import RequestStatusBar from '../request-form/RequestStatusBar';
import { DownOutlined } from '@ant-design/icons';
import RequestDetailMainInformation from '../request-form/RequestDetailMainInformation';
import React, { useState } from 'react';
import NormalTicketOpenProcessing from './NormalTicketOpenProcessing';
import NormalRequestDetailCreateInformation from './NormalTicketDetailCreateInformation';
import RequestDetailCmisTransferInformation from '../request-form/RequestDetailCmisTransferInformation';
import ticketDetailed from '../ticket-detailed/TicketDetailed';
import CloneNormalTicketOpenProcessing from './CloneNormalTicketOpenProcessing';
import RequestDetailCreateFormInformation from 'components/request-form/RequestDetailCreateFormInformation';

interface NormalTikcetProps {
  ticket: TicketDetail;
  status?: string;
  ticketId: number;
}
const CloneNormalTicket: React.FC<NormalTikcetProps> = ({ ticket, status }) => {
  const [processingContent, setProcessingContent] = useState<string>('');

  return (
    <div className='p-5 w-[1300px]'>
      <div className='flex justify-center'>
        <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
          {requestform.requestTicketCRM}
        </Typography.Text>
      </div>
      <div className='flex w-full p-2 text-left'>
        <div className='flex items-center w-[250px]'>
          {/* <NormalRequestDetailCreateInformation requestItem={ticket} /> */}
          <RequestDetailCreateFormInformation requestItem={ticket}/>
        </div>
        <div className='flex  flex-col justify-between'>
          <section className='w-[870px] p-6'>
            <section className='items-center justify-between'>
              <div className='w-4/5'>
                <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
                  {requestform.serviceType}
                </Typography.Text>
              </div>
              <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
                {ticket?.serviceType?.name ? ticket.serviceType.name.split(' ').slice(0, 20).join(' ') : ''}
              </Typography.Text>
            </section>

            <section>
              <Typography.Text
                className={`text-[14px]/[18px] ${ticket?.isRequestMultipleTime ? 'text-[#D1131D]' : 'text-[#06A77D]'}`}
              >
                {ticket?.isRequestMultipleTime ? requestform.multiplleTimeRequest : requestform.notMultiplleTimeRequest}
              </Typography.Text>
            </section>

            <section className='pb-6'>
              <RequestStatusBar status={status} />
              <RequestDetailCmisTransferInformation ticketDetail={ticket} />
            </section>

            <section className={`h-[1000px]`}>
              <RequestDetailMainInformation requestItem={ticket} />
              <CloneNormalTicketOpenProcessing requestItem={ticket} isHistory={true} processingContent={processingContent} />
            </section>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CloneNormalTicket;
